<template>
  <!-- Seller data -->
  <b-row v-if="parcel.seller">
    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Seller name"
        rules="required"
      >
        <label>Seller name</label>
        <b-form-input
          v-model="parcel.seller.name"
          v-b-tooltip.hover.top="getIssueMessage('seller.name')"
          :class="getIssueClass('seller.name')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <label>Seller IOSS number</label>
      <b-form-input
        v-model="parcel.seller.registry_number"
        v-b-tooltip.hover.top="getIssueMessage('seller.registry_number')"
        :class="getIssueClass('seller.registry_number')"
        :disabled="disabled"
        class="mr-0 ml-0"
      />
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Seller street number"
        rules="required"
      >
        <label>Seller street number</label>
        <b-form-input
          v-model="parcel.seller.street_and_number"
          v-b-tooltip.hover.top="getIssueMessage('seller.street_and_number')"
          :class="getIssueClass('seller.street_and_number')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Seller postal code"
        rules="required|max:20"
      >
        <label>Seller postal code</label>
        <b-form-input
          v-model="parcel.seller.postal_code"
          v-b-tooltip.hover.top="getIssueMessage('seller.postal_code')"
          :class="getIssueClass('seller.postal_code')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Seller city"
        rules="required"
      >
        <label>Seller city</label>
        <b-form-input
          v-model="parcel.seller.city"
          v-b-tooltip.hover.top="getIssueMessage('seller.city')"
          :class="getIssueClass('seller.city')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <label>Seller region</label>
      <b-form-input
        v-model="parcel.seller.region"
        v-b-tooltip.hover.top="getIssueMessage('seller.region')"
        :class="getIssueClass('seller.region')"
        :disabled="disabled"
        class="mr-0 ml-0"
      />
    </b-col>

    <b-col
      lg="3"
      md="4"
    >
      <validation-provider
        #default="{ errors }"
        name="Seller country"
        rules="required|min:2|max:2|alpha"
      >
        <label>Seller country</label>
        <b-form-input
          v-model="parcel.seller.country"
          v-b-tooltip.hover.top="getIssueMessage('seller.country')"
          :class="getIssueClass('seller.country')"
          :disabled="disabled"
          class="mr-0 ml-0"
          :state="errors.length > 0 ? false:null"
        />
      </validation-provider>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import errorHighlightingMixin from '@/mixins/errorHighlightingMixin'

export default {
  components: {
    ValidationProvider,
    BRow,
    BCol,
    BFormInput,
  },
  mixins: [errorHighlightingMixin],
  props: {
    parcel: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/base/bootstrap-extended/variables';

.input-warning {
  background: lighten($warning, 35%);
  border: 1px solid $warning;
}
.input-danger {
  background: lighten($danger, 30%);
  border: 1px solid $danger;
}
</style>
